import styled from 'styled-components';

export const LoadMoreButton = styled.div`
  cursor: pointer;
  background: var(--primary-background);
  margin-top: auto;
  padding: 8px;
  color: gray;
  width: 100%;
  text-align: center;
`;
